import { render } from "./NamecardManage.vue?vue&type=template&id=c5bedac6"
import script from "./NamecardManage.vue?vue&type=script&lang=js"
export * from "./NamecardManage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__